import "./ScrollableTable.css";

/** Strip overflow — inline overflow on the wrapper breaks sticky headers. */
function withoutOverflow(style) {
  if (!style) return {};
  const { overflow, overflowX, overflowY, ...rest } = style;
  return rest;
}

/**
 * Wraps a <table> so the header row stays fixed while the body scrolls
 * (Excel-like vertical scroll).
 */
export default function ScrollableTable({
  children,
  className = "",
  style,
  scroll = true,
}) {
  const classes = [
    "app-table-sticky",
    scroll ? "app-table-scroll scrollable" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const wrapperStyle = scroll
    ? {
        ...withoutOverflow(style),
        flex: 1,
        minHeight: 0,
        overflowX: "auto",
        overflowY: "auto",
      }
    : withoutOverflow(style);

  return (
    <div className={classes} style={wrapperStyle}>
      {children}
    </div>
  );
}
